<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {usePage} from "@inertiajs/vue3";
  import PatientinputComponentStep from "@pages/Patientinput/Components/Step.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PatientinputComponentStepWelcomePatient",
  });

  defineProps({
    form: {
      type: Object,
      required: true,
    },
  });

  defineEmits(["navigate"]);

  const page = usePage();

  const company = computed(() => page.props.company);
</script>

<template>
  <PatientinputComponentStep
    :forward-button="false"
    :back-button="false"
    :navigation-horizontal="false"
    :test-id="getTestId()"
  >
    <template #title>
      <Teleport defer to="#patientinput-layout-header">
        <header>
          <img src="@images/logo/mc_logo.svg" width="250" alt="MediCheck" class="mt-3" />
        </header>
      </Teleport>
    </template>

    <h1 class="text-center text-3xl font-medium md:text-4xl">Herzlich willkommen …</h1>

    <img src="@images/hero-image.jpg" alt="" class="rounded" />

    <p>
      … zur Vorerfassung für Ihre Medikationsberatung
      <span v-if="company">bei {{ company }}</span>
      (Dauer ca. 10 Minuten).
    </p>

    <div>
      <p>Idealerweise haben Sie Folgendes gleich bereitliegen:</p>

      <ul class="ml-5 list-disc">
        <li>Falls vorhanden: Medikationsplan oder andere Anwendungspläne, Dosierungsanweisungen etc.</li>
        <li>
          Alle Medikamente, die Sie anwenden (verordnet, rezeptfrei, pflanzlich, äußerlich anzuwenden, Vitamine,
          Mineralstoffe, Nahrungsergänzungsmittel, etc.)
        </li>
      </ul>
    </div>

    <p>
      Verantwortlich für die Datenverarbeitung im Sinne der DSGVO ist
      <span v-if="company">{{ company }}.</span>
      <span v-else>Ihre Apotheke.</span>
    </p>

    <div class="align-start flex space-x-2 text-blue-900">
      <ComponentIcon class="inline-block text-2xl text-blue-600">info</ComponentIcon>
      <p>
        Mit der Eingabe willige ich ausdrücklich in die Verarbeitung meiner Gesundheitsdaten gemäß Datenschutzerklärung
        ein.
      </p>
    </div>

    <template #navigation>
      <MedButton
        :data-test="getTestId('welcome-patient-step-start-button')"
        variant="primary"
        @click="$emit('navigate', '+')"
      >
        Mit der Eingabe starten
      </MedButton>
    </template>
  </PatientinputComponentStep>
</template>
